// extracted by mini-css-extract-plugin
module.exports = {"Search":"Search_Search__26mim","isHeader":"Search_isHeader__3Xaai","isMenu":"Search_isMenu__3ORRe","focus":"Search_focus__393-R"};